import { isEmpty, type Optional } from '@festina-life/core'
import { useTranslateEnum } from '@festina-life/ui/hooks'
import { useCallback } from 'react'

import { stripMigrationFromName } from './useTranslatePolicy'

export const useTranslateCover = () => {
  const translateEnum = useTranslateEnum()

  return useCallback(
    (coverKey: Optional<string>) => {
      if (isEmpty(coverKey)) {
        return '-'
      }

      const [templateIdentifier, coverNumber] =
        stripMigrationFromName(coverKey).split('#')

      const translatedCover = translateEnum(
        'life.enum.CoverType',
        templateIdentifier,
      )

      return isEmpty(coverNumber)
        ? translatedCover
        : `${translatedCover} #${coverNumber}`
    },
    [translateEnum],
  )
}
